module.exports = __webpack_public_path__ + "img/homepage-gift.65457c1.svg";